import axios from "axios"
import moment from 'moment'
import { I18n, setLocale } from 'react-redux-i18n'

import {history} from "../helpers/history"

import {defaultConfig} from "../config"

import {checkOtherUserLoggedIn} from "./otherUserActions"

import {getHeaders} from "../helpers/urlHelper"

//User login action
export function login(username, password) {
  return function(dispatch) {
    dispatch({type: "USER_FETCH_LOGIN"})

    axios.post(defaultConfig.url + "/login", {
        "user":username,
        "password":password
      })
      .then((response) => {
        const expires_at = moment().add(response.data.expires_in, 'seconds')

        //Set local storage token
        localStorage.setItem('login_token', response.data.access_token)
        localStorage.setItem('expires_at', expires_at.unix())
        localStorage.setItem('user', JSON.stringify(response.data.user))

        //Set logged in to true
        dispatch({type: "USER_FETCH_LOGIN_FULFILLED", payload: {
          user: response.data.user,
          expires_at: expires_at
        }})

        // Set settings preferences
        dispatch({type: "USER_SET_HOMEPREFERENCE", payload: response.data.user.preference})

        // Set language
        dispatch(setLocale(response.data.user.talen.taalcode.toLowerCase()))
        // Set moment language
        moment.updateLocale(response.data.user.talen.taalcode.toLowerCase())

        // Show success snackbar
        dispatch({type: "SHOW_SNACKBAR", payload: {
          variant: 'success',
          message: I18n.t('global.logged_in'),
          verticalPosition: 'bottom',
          horizontalPosition: 'center',
          duration: 1600
        }})

        if(response.data.user.preference === "w"){
          history.push(`/week/${moment().format('YYYYMMDD')}`)
        }else{
          history.push(`/month/${moment().format('YYYYMMDD')}`)
        }
      })
      .catch((err) => {
        dispatch({type: "USER_FETCH_LOGIN_REJECTED", payload: err})

        if(err.response && err.response.status === 401) {

          // Show error snackbar
          dispatch({type: "SHOW_SNACKBAR", payload: {
            variant: 'error',
            message: err.response.data.message,
            verticalPosition: 'bottom',
            horizontalPosition: 'center',
            duration: 3000
          }})

          // Log user out
          // Delete localStorage login token
          localStorage.removeItem('login_token')
          localStorage.removeItem('user')
          localStorage.removeItem('login_expires_at')

          // Delete otheruser localStorage login token
          localStorage.removeItem('other_user_token')
          localStorage.removeItem('other_user_expires_at')
          localStorage.removeItem('other_user')

          dispatch({type: "USER_LOGOUT"})

          // Send user to login page
          history.push('/login')
        }else{
          // Show error snackbar
          dispatch({type: "SHOW_SNACKBAR", payload: {
            variant: 'error',
            message: I18n.t('global.server_error'),
            verticalPosition: 'bottom',
            horizontalPosition: 'center',
            duration: 5000
          }})

        }
      })
  }
}

//Check if user is logged in when reloading page
export function checkLoggedIn(){
  return function(dispatch) {
    if(localStorage.getItem('login_token')){

      const expires_at_old = moment.unix(localStorage.getItem('expires_at'))

      // Check if token expired on client side
      if(moment().diff(expires_at_old) > 0) {
        // Show error snackbar
        dispatch({type: "SHOW_SNACKBAR", payload: {
          variant: 'error',
          message: I18n.t('global.session_expired'),
          verticalPosition: 'bottom',
          horizontalPosition: 'center',
          duration: 5000
        }})


        //Delete localStorage login token
        localStorage.removeItem('login_token')
        localStorage.removeItem('user')
        localStorage.removeItem('expires_at')

        // Delete otheruser localStorage login token
        localStorage.removeItem('other_user_token')
        localStorage.removeItem('other_user_expires_at')
        localStorage.removeItem('other_user')

        //Set logged in to false
        dispatch({type: "USER_LOGOUT"})

        // Send user to login page
        history.push('/login')

        return
      }

      dispatch({
        type: "USER_CHECK_LOGGED_IN"
      })

      axios.post(defaultConfig.url + "/refresh", null, {
          headers: getHeaders()
        })
        .then((response) => {
          const expires_at_new = moment().add(response.data.expires_in, 'seconds')

          //Set local storage token
          localStorage.setItem('login_token', response.data.access_token)
          localStorage.setItem('user', JSON.stringify(response.data.user))
          localStorage.setItem('expires_at', expires_at_new.unix())

          // Set settings preferences
          dispatch({type: "USER_SET_HOMEPREFERENCE", payload: response.data.user.preference})

          // Set language
          dispatch(setLocale(response.data.user.talen.taalcode.toLowerCase()))
          // Set moment language
          moment.updateLocale(response.data.user.talen.taalcode.toLowerCase())

          // Set user logged in
          dispatch({
            type: "USER_LOGGED_IN",
            payload: {
              user: response.data.user,
              expires_at: expires_at_new
            }
          })
        })
        .catch((err) => {
          if(err.response && err.response.status === 401) {
            // Show error snackbar
            dispatch({type: "SHOW_SNACKBAR", payload: {
              variant: 'error',
              message: I18n.t('global.session_expired'),
              verticalPosition: 'bottom',
              horizontalPosition: 'center',
              duration: 5000
            }})

            // Log user out
            //Delete localStorage login token
            localStorage.removeItem('login_token')
            localStorage.removeItem('user')
            localStorage.removeItem('expires_at')

            // Delete otheruser localStorage login token
            localStorage.removeItem('other_user_token')
            localStorage.removeItem('other_user_expires_at')
            localStorage.removeItem('other_user')

            //Set logged in to false
            dispatch({type: "USER_LOGOUT"})

            // Send user to login page
            history.push('/login')
          }else{
            // Show error snackbar
            dispatch({type: "SHOW_SNACKBAR", payload: {
              variant: 'error',
              message: I18n.t('global.server_error'),
              verticalPosition: 'bottom',
              horizontalPosition: 'center',
              duration: 5000
            }})

            // Set logged in to true if session didn't expire
            dispatch({
              type: "USER_LOGGED_IN",
              payload: {
                user: JSON.parse(localStorage.getItem('user')),
                expires_at: expires_at_old
              }
            })

          }
        })
    }

    dispatch(checkOtherUserLoggedIn())
  }
}

export function logout(){
  return function(dispatch) {
    //Delete localStorage login token
    localStorage.removeItem('login_token')
    localStorage.removeItem('user')
    localStorage.removeItem('expires_at')

    // Delete otheruser localStorage login token
    localStorage.removeItem('other_user_token')
    localStorage.removeItem('other_user_expires_at')
    localStorage.removeItem('other_user')

    //Set logged in to false
    dispatch({type: "USER_LOGOUT"})

    //Set logged in to false
    dispatch({type: "OTHER_USER_LOGOUT"})

    // Send user to login page
    history.push('/login')
  }
}



// WEBPACK FOOTER //
// ./src/js/actions/userActions.js